import React, { useState } from 'react';
import { VerifiedIcon } from '../../../../../assets/icons';
import './styles.css';

const Verified = ({ abn, acn }) => {
  const [tooltip, setTooltip] = useState();
  return (
    !!(abn || acn) && (
      <div
        className="Listview__Card__verified"
        onMouseEnter={() => setTooltip(true)}
        onMouseLeave={() => setTooltip(false)}
      >
        {tooltip && (
          <div className="Listview__Card__verified__toolTip">
            <p>Verified business</p>
          </div>
        )}
        <VerifiedIcon />
      </div>
    )
  );
};

export default Verified;
